import { render, staticRenderFns } from "./threeRecommend.vue?vue&type=template&id=dc2073f4&"
import script from "./threeRecommend.vue?vue&type=script&lang=js&"
export * from "./threeRecommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports